import { SchemaContext as AcqeFeSchemaContext } from '@99designs/acquisition-frontend/shared/components/Schema/SchemaContext';
import {
    SchemaContext as MarketingUISchemaContext,
    OrganizationSchema,
} from '@99designs/marketing-ui';
import CategoryConfigProvider from '../components/CategoryPage/CategoryConfigProvider';
import CategoryPageLayout from '../components/CategoryPage/CategoryPageLayout';
import type { Design } from '@99designs/feature-design-inspiration';
import type { Site } from '@99designs/frontend-components/apps/global-nav/lib/Site';
import type { ProductGroupPrice } from '../types';
import type { ProductGroup } from './productLandingGroups';

export interface ProductLandingPageProps {
    randomFeaturedDesignerNumber: number;
    categoryKey: string;
    site: Site;
    inspirationDesigns: Design[];
    productGroupPrices: ProductGroupPrice[];
    productGroup: ProductGroup;
}

export function ProductLandingPage({
    categoryKey,
    site,
    inspirationDesigns,
    productGroup,
    productGroupPrices,
}: ProductLandingPageProps) {
    return (
        // We have components using the SchemaContext from marketing-ui and from acquisition-frontend
        // We should be able to remove the acquisition-frontend one during the next iteration of this
        // page, where the current thinking is that the reviews and resources section will be replaced.
        // For now, this is needed to get the structured data showing the correct domain in its payload.
        <AcqeFeSchemaContext.Provider value={{ site: site.getDomain() }}>
            <MarketingUISchemaContext.Provider value={{ site: site.getDomain() }}>
                <CategoryConfigProvider
                    language={site.getLanguageCode()}
                    categoryKey={categoryKey}
                    render={(category) => (
                        <CategoryPageLayout
                            site={site}
                            randomFeaturedDesignerNumber={10} // TODO use props.randomFeaturedDesignerNumber
                            category={category}
                            inspirationDesigns={inspirationDesigns}
                            productGroupPrices={productGroupPrices}
                            productGroup={productGroup}
                        />
                    )}
                />

                <OrganizationSchema
                    lang={site.getLanguage().rfc.toLowerCase()}
                    supportPhone={site.get('phone.support')}
                    sameAs={[
                        `https://www.facebook.com/${site.getSocialMediaHandleFor('facebook')}`,
                        `https://twitter.com/${site.getSocialMediaHandleFor('twitter')}`,
                        'https://www.instagram.com/99designs',
                        'https://www.youtube.com/channel/UC-xU--XxSovzJq07jwmZrsw',
                        'https://www.pinterest.com/99designs',
                    ]}
                />
            </MarketingUISchemaContext.Provider>
        </AcqeFeSchemaContext.Provider>
    );
}

export default ProductLandingPage;
